import _filter from 'lodash.filter'
import _orderBy from 'lodash.orderby'
import axios from 'plugins/axios'
import search from 'mixins/search'
import locales from 'plugins/wsc-locales'
import { translatableOrDefault } from '../plugins/wsc-translatable'
import _get from 'lodash/get'
import {usedLocale} from '../plugins/wsc-locales'

export const state = {
  list: [],
  filteredList: [],
  count: 0,
  completeListRequested: false,
  filter: {
    name: '',
    category: null
  },
  order: [{
    direction: 'desc',
    field: 'created_at'
  }],
  page: 1,
  pageCount: 0
}

export const getters = {
  products (state) {
    return _filter(state.list, product => _get(product, ['translatable', locales.usedLocale, 'visible'], false))
  },
  filteredProducts (state, getters) {
    let products = getters.products

    // filter products by category
    if (state.filter.category) {
      products = products.filter(product => product.categories.includes(state.filter.category))
    }

    // filter products by searchstring
    if (state.filter.name.length > 0) {
      products = _filter(products, product => {
        return search(state.filter.name, [
          translatableOrDefault(product, 'name')
        ])
      })
    }

    // create a new virtual property that contains the price for sorting
    products = products.map(p => ({
      ...p,
      sorting_name: translatableOrDefault(p, 'name'),
      sorting_price: p.use_discount_price ? p.default_discount_price : p.default_price
    }))

    let order = state.order || []
    return _orderBy(products, order.map(item => item.field), order.map(item => item.direction))
  },
  requestedProducts (state) {
    return state.filteredList
  },
  countProducts (state) {
    return state.list.length
  },
  countFilteredProducts (state, getters) {
    return state.count
  },
  allSelected (state) {
    if (!state.list.length) return false
    return state.list.reduce((acc, product) => acc && product.isSelected, true)
  },
  hasSelected (state) {
    if (!state.list.length) return false
    return state.list.reduce((acc, product) => acc || product.isSelected, false)
  },
  filterName (state) {
    return state.filter.name
  },
  filterCategory (state) {
    return state.filter.category
  },
  order (state) {
    return state.order ? state.order[0] : null
  },
  page (state) {
    return state.page
  },
  countPages (state) {
    return state.pageCount
  },
  getProductById: (state, getters) => (id) => {
    if (state.list.length === 0) return null
    return state.list.find(product => product.id === id)
  },
  getVariationForProduct: (state, getters) => (productId, variationId) => {
    let product = getters.getProductById(productId)
    if (!product || !product.variations) return null

    return product.variations.find(variation => variation.id === variationId)
  },
  getProductsOfCategory: (state) => ({id}) => {
    return state.list.filter(product => product.categories.includes(id))
  }
}

export const mutations = {
  add (state, product) {
    let oldProduct = state.list.find(p => p.id === product.id)

    if (oldProduct) {
      if (product.images[0] && oldProduct.images[0]) {
        product.images[0].thumbnails = {...oldProduct.images[0].thumbnails, ...product.images[0].thumbnails}
      }

      return state.list.splice(state.list.indexOf(oldProduct), 1, {
        ...oldProduct,
        ...product
      })
    }

    return state.list.push({
      ...product,
      isSelected: false
    })
  },
  replace (state, product) {
    let oldProduct = state.list.find(p => p.id === product.id)

    state.list.splice(state.list.indexOf(oldProduct), 1, {
      ...product,
      ...oldProduct,
      isSelected: oldProduct.isSelected
    })
  },
  setFilterName (state, search) {
    state.filter.name = search
  },
  setFilterCategory (state, category) {
    state.filter.category = category || undefined
  },
  setOrder (state, order) {
    state.order = [order]
  },
  setPage (state, page) {
    state.page = page
  },
  refreshStock (state, stockUpdateObject) {
    let oldProduct = state.list.find(p => p.id === stockUpdateObject.id)

    oldProduct.stock = stockUpdateObject.stock
    oldProduct.use_stock = stockUpdateObject.use_stock
  }
}

export const actions = {
  async request ({state, commit}) {
    if (state.completeListRequested) return
    let {data} = await axios.get('/products')
    data.data.forEach(product => commit('add', product))

    state.completeListRequested = true
  },

  async requestFiltered ({state, commit, getters}, device) {
    const request = {
      page: getters.page,
      category: getters.filterCategory,
      order: {
        direction: getters.order.direction,
        field: getters.order.field
      },
      search: getters.filterName,
      device: device,
      locale: usedLocale
    }

    let {data} = await axios.post(`/products/filtered?id=${Math.random()}`, request)

    state.count = data.count
    state.pageCount = data.pages
    state.filteredList = data.data
  },

  async requestDetailed ({commit}, id) {
    let {data} = await axios.get(`/products/${id}`)
    commit('add', data.data)
  },

  async refreshStock ({commit}, id) {
    let {data} = await axios.get(`/products/${id}/stock`)
    commit('refreshStock', data.data)
  },

  setFilterCategory ({commit}, category) {
    commit('setFilterCategory', category)
  },

  setPage ({commit}, page) {
    commit('setPage', page)
  }
}



// WEBPACK FOOTER //
// ./client/store/products.js